import React, { useState, useMemo, useRef } from 'react';
import { Table, Col, Row, Button, FormGroup, Pagination, PaginationItem, PaginationLink, Form, Input, Label } from 'reactstrap';
import { useTranslate } from 'react-translate';
import { useSortBy, useTable, usePagination } from 'react-table';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import history from 'historyRouter';
import MultimediaService from "../../services/MultimediaService";
import moment from "moment";
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import nativeSender from 'helpers/nativeSender';
import { useSelector, useDispatch } from 'react-redux';
import Icon from 'components/Icons/Icon';
import ReactTooltip from 'react-tooltip';
import PdfLoadingButton from 'components/Common/Laboratory/LaboratoryPdfDownload';

import { 
    actionGetLabStudies,
    actionSetLoadingStudy, 
    actionSetSearchQuery, 
    actionSaveCurrentLaborScroll,
    actionSetFromDetailsLabor,
    actionSetPageIndex,
    actionSetLoadingStudyList
} from 'store/actions/laboratoryActions';

const StudiesList = () => {
  const dispatch = useDispatch();
  const { handleSubmit, register } = useForm();
  const t = useTranslate('studies-list');
  const thl7 = useTranslate('hl7-status');
  const laboratoryList = useSelector(state => state.laboratoryReducer.studies);
  const refreshTable = useRef(false);
  const [sortDate, setSortDate] = useState(-1);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const querySearch = useSelector(state => state.laboratoryReducer.querySearch);
  const coming = useSelector(state => state.laboratoryReducer.comingFromDetails);
  const scroll = useSelector(state => state.laboratoryReducer.laborListScroll);
  const lastPage = useSelector(state => state.laboratoryReducer.lastPage);
  const pageLimit = useSelector(state => state.laboratoryReducer.limit);
  const pageState = useSelector(state => state.laboratoryReducer.page);
  const totalEntries = useSelector(state => state.laboratoryReducer.totalEntries);
  const loadingStudyList = useSelector(state => state.laboratoryReducer.loadingStudyList);
  
  const [showDatePick, setShowDatePick] = useState(false);

  const onSubmit = (data) => {
      const query = data.query.trim();
      dispatch(actionSetSearchQuery(query));
      gotoPage(0);
  }

  const data = useMemo(
    () => laboratoryList && laboratoryList.length && laboratoryList != "loading" ? laboratoryList.map(p => {

      const reportData = {
        eingangsdatum: p?.created_at ? moment(p?.created_at, "YYYYMMDDhhmmss").format("DD/MM/YYYY") : "",
        status: p?.status ? `${thl7(p?.status)}` : "",
        studyType: p.studyType ? t(p.studyType.toLowerCase().replace(" ", "-")) : "-",
        arzt: <><small>{p.doctor?.title}</small> <br/> {p.doctor?.lastName}</>,
        c5: p?.readed ? "true" : "",
        reportid: p.reportId,
        c6: <>
          <Button
            color="info"
            onClick={() => {
              history.push(`lab-studies-detail/${p?._id}`);
            }}
          >
            {t('details')}
          </Button>

          <ReactTooltip 
              id={`new-message-${p?._id}`}
              aria-haspopup="true"
              effect="float"
              type="dark"
              place="bottom"
            >
              {t('new-doctor-review')}
            </ReactTooltip>

          {!p?.new_review ? <></> : 
          <>
            <span 
              style={{cursor: "pointer"}}
              data-tip 
              data-for={`new-message-${p?._id}`} 
              onClick={() => {history.push(`lab-studies-detail/${p?._id}/review`);}}
            >
              <Icon file="medical-report_TP.svg" width="40px" className="ml-2 mt-2"/>
            </span>
          </>
          }
          
        </>,
        c7: p.reportFileExists ? <PdfLoadingButton 
                reportId={p._id} 
                doctorId={p.doctor.auth_user_id} 
                patientId={p.patient.auth_user_id}
                prompt={<i className="icon icon-attach ml-2"></i>}
                buttonSize="sm"
        /> : <></>
      };

      return { ...reportData };
    }) : [],
    //eslint-disable-next-line
    [laboratoryList, t]
  );


  const columns = useMemo(
    () => [
      {
        Header: `${t('actions')}`,
        accessor: "c6",
        disableSortBy: true
      },
      {
        Header: `ID`,
        accessor: "reportid",
        disableSortBy: true
      },
      {
        Header: `${t('study-type')}`,
        accessor: "studyType"
      },
      {
        Header: `${t('date-of-receipt')}`,
        accessor: "eingangsdatum",
        defaultCanSort: true
      },
      {
        Header: `Arzt`,
        accessor: "arzt",
        disableSortBy: true
      },
      {
        Header: `${t('status')}`,
        accessor: "status",
        defaultCanSort: true
      },
      {
        Header: `${t('pdf')}`,
        accessor: "c7",
        disableSortBy: true
      }
      // {
      //   Header: "Ordered",
      //   accessor: "ordered",
      //   defaultCanSort: true
      // },
      // {
      //   Header: `Doctor`,
      //   accessor: "doctor",
      //   defaultCanSort: true,
      // },
      // {
      //   Header: `Email`,
      //   accessor: "doctorEmail",
      //   defaultCanSort: true
      // },
      // {
      //   Header: `Actions`,
      //   accessor: "c6",
      //   disableSortBy: true
      // }
    ],
    //eslint-disable-next-line
    [t]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize }
  } = useTable({
    columns,
    data,
    initialState: {
      pageSize: pageLimit,
      pageIndex: pageState,
    },
    manualPagination: true,
    pageCount: lastPage + (totalEntries > pageLimit),
    autoResetPage: !refreshTable.current
  },
    useSortBy,
    usePagination);

  const goToPageNumber = (page) => {
      dispatch(actionSetPageIndex(page));
      gotoPage(page);
  }

  const goNextPage = () => {
      dispatch(actionSetPageIndex(pageIndex + 1));
      nextPage();
  }

  const goPreviousPage = () => {
      dispatch(actionSetPageIndex(pageIndex - 1));
      previousPage();
  }

  useEffect(() => {
        refreshTable.current = true;
        document.getElementById("full-page").scroll(0,0);
        dispatch(actionGetLabStudies({
            pageIndex, 
            pageSize, 
            sortDate, 
            querySearch, 
            dateFrom,
            dateTo
        }));
    }, [pageIndex, pageSize, sortDate, querySearch]);

    //Setup scroll effect after component loading
    useEffect(() => {
        if (!loadingStudyList && laboratoryList.length && scroll && coming) {
            document.getElementById("full-page").scrollTop = scroll;
            dispatch(actionSaveCurrentLaborScroll(0));
            dispatch(actionSetFromDetailsLabor(false));
        } else {
            document.getElementById("full-page").scrollTop = 0;
        }
    }, [laboratoryList]);

  useEffect(() => {
    refreshTable.current = false;
  }, []);

  //Pagination info
  const firstEntry = (pageIndex * pageLimit) + 1;
  const lastEntry = (pageIndex * pageLimit) + pageLimit > totalEntries ? totalEntries : (pageIndex * pageLimit) + pageLimit;
  const pageInfo = totalEntries > 0 ? t("pagination-info", {firstEntry, lastEntry, totalEntries}) : t("no-results");

  return (
    <>

    <Form onSubmit={handleSubmit(onSubmit)}>
      <Row>
          <Col xs={4} sm={3}>
              <FormGroup
              className="mt-2">
                  <Input 
                  className="form-control"
                      type="text"
                      innerRef={register}
                      name="query"
                      id="query"
                      placeholder={t('search-patient')}
                      defaultValue={querySearch}
                  />

                  {querySearch.length ? (
                      <button 
                      className="msg_send_btn" 
                      type="button" 
                      onClick={() => {
                          document.getElementById("query").value = "";
                              dispatch(actionSetSearchQuery(""))
                          }}>
                          <span className="icon-trash"></span>
                    </button>
                  ) : (<></>)}
              </FormGroup>
          </Col>

          <Col xs={1}>
              <Button
                  size="md"
                  color="info"
                  type="submit"
                  name="search-study"
              >
                  {t("search-button")}
              </Button>
          </Col>

          <Col className="ml-auto mr-3" xs={4} lg={3}>
              <FormGroup className="mt-2">
                  <Input type="select" name="filter-date-study" onChange={(e) => {
                      setShowDatePick(isNaN(new Date(e.target.value)));
                      let date = new Date(e.target.value);
                      if (!isNaN(date)) {
                          if (date.getFullYear() < 1900) {
                              setDateFrom(null);
                              setDateTo(null);
                          } else {
                              setDateFrom(e.target.value);
                          }
                          setShowDatePick(false);
                      }
                  }}>
                      <option value={"1800-01-01"} selected>
                          {t("datepick-show-all")}
                      </option>
                      <option value={moment(Date.now() - 7 * 24 * 60 * 60 * 1000).format("YYYY-MM-DD")}>
                          {t("datepick-last7")}
                      </option>
                      <option value={moment(Date.now() - 30 * 24 * 60 * 60 * 1000).format("YYYY-MM-DD")}>
                          {t("datepick-last-month")}
                      </option>
                      <option>
                          {t("datepick-personalized")}
                      </option>
                  </Input>
                </FormGroup>
          </Col>

          
      </Row>

      {showDatePick && (
          <Row>
              <Col>
                  <Label>{t('datepick-from')}</Label>
                  <FormGroup>
                      <Input
                          name="from"
                          id="from"
                          type="date"
                          innerRef={register}
                          onChange={(e) => {
                              setDateFrom(e.target.value);
                          }}
                      />
                  </FormGroup>
              </Col>

              <Col>
                  <Label>{t('datepick-to')}</Label>
                  <FormGroup>
                      <Input
                          name="to"
                          id="to"
                          type="date"
                          innerRef={register}
                          onChange={(e) => {
                              setDateTo(e.target.value);
                          }}
                      />
                  </FormGroup>
              </Col>
          </Row>
      )}
  </Form>


      <div className="mobile-x-overflow">
        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  column.id === "eingangsdatum" ? (
                    
                    <th
                    className={`session-table-header ${column.id === "c4" ? "sortable-header" : ""}`}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    onClick={e => {
                      setSortDate(!sortDate ? 1 : sortDate === 1 ? -1 : 0);
                    }}
                  >
                    {/* Sortable date header */}
                    {column.render('Header')}
                    <span>
                      <b className={`${sortDate != 0 ? sortDate === -1 ? "caret-desc" : "caret-asc" : "caret-default"}`}></b>
                    </span>
                  </th>
                  ) : (
                    <th
                    className={`session-table-header ${column.id === "c4" ? "sortable-header" : ""}`}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {/* Sortable status */}
                    {column.render('Header')}

                    {column.id === "status" && (
                      <span>
                        <b className={`${column.isSorted ? column.isSortedDesc ? "caret-desc" : "caret-asc" : "caret-default"}`}></b>
                      </span>
                    )}

                  </th>
                  )
                  
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {loadingStudyList ? (<tr><td><LoadingLocal /></td></tr>)
              : (
                page.map(row => {
                  prepareRow(row)
                  return (
                    <tr 
                      {...row.getRowProps((state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                          return {
                              style: {
                                  fontWeight: !rowInfo.row.original.c5.length ? 'bold' : 'normal',
                              }
                          }
                      } else return {}
                      })}
                    >
                      {row.cells.map(cell => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            className={cell.column.id === "c1" ? `d-flex` : ""}
                          >
                            {cell.column.id === "c1" && <div className={`dot-${cell.value === "Unavailable" ? "un" : ''}available`}></div>}
                            {cell.render('Cell')}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })
              )}
          </tbody>
        </Table>
      </div>

      <Row className="text-center justify-content-center mt-3">
        <nav aria-label="Page navigation example">
          <Pagination
              className="pagination justify-content-end"
              listclassname="justify-content-end"
          >
              <PaginationItem disabled={!canPreviousPage}>
                  <PaginationLink
                      href="#previous-page"
                      onClick={e => {
                          e.preventDefault()
                          goPreviousPage()
                      }}
                      tabIndex="-1"
                      className="bg-info text-white"
                  >
                      <i className='fa fa-angle-double-left'></i>
                  </PaginationLink>
              </PaginationItem>
              <PaginationItem disabled={pageIndex < 2}>
                  <PaginationLink href="#minus-two" onClick={e => {
                      e.preventDefault();
                      goToPageNumber(pageIndex - 2);
                  }}>
                      {canPreviousPage && pageIndex > 1 ? pageIndex - 1 : " "}
                  </PaginationLink>
              </PaginationItem>
              <PaginationItem disabled={pageIndex === 0}>
                  <PaginationLink href="#minus-one"
                      onClick={e => {
                          e.preventDefault();
                          goPreviousPage()
                      }}>
                      {!canPreviousPage ? " " : pageIndex}
                  </PaginationLink>
              </PaginationItem>
              <PaginationItem active>
                  <PaginationLink href="#actual-page" onClick={e => { e.preventDefault() }} className="bg-info">
                      {pageIndex + 1}
                  </PaginationLink>
              </PaginationItem>
              <PaginationItem disabled={!canNextPage}>
                  <PaginationLink href="#plus-one" onClick={e => {
                      e.preventDefault();
                      goNextPage();
                  }}>
                      {canNextPage ? pageIndex + 2 : " "}
                  </PaginationLink>
              </PaginationItem>
              <PaginationItem disabled={!(pageCount - pageIndex > 2)}>
                  <PaginationLink href="#plus-two" onClick={e => {
                      e.preventDefault();
                      goToPageNumber(pageIndex + 2);
                  }}>
                      {(pageCount - pageIndex > 2) ? pageIndex + 3 : " "}
                  </PaginationLink>
              </PaginationItem>
              <PaginationItem disabled={!canNextPage}>
                  <PaginationLink href="#next-page" onClick={e => {
                      e.preventDefault();
                      goNextPage();
                  }}
                      className="bg-info text-white"
                  >
                      <i className='fa fa-angle-double-right'></i>
                  </PaginationLink>
              </PaginationItem>
          </Pagination>

          <Label>{pageInfo}</Label>
        </nav>
      </Row>
    </>

  );
};

export default StudiesList;
